import { api } from "../lib/api";
import type {
	QuestionnaireAnswersResponse,
	SaveQuestionnaireRequest,
} from "../types/questionnaire";

export async function getQuestionnaireAnswers(): Promise<QuestionnaireAnswersResponse> {
	const response = await api.get<QuestionnaireAnswersResponse>(
		"/api/questionnaire-answers",
	);
	return response.data;
}

export async function saveQuestionnaireAnswers(
	data: SaveQuestionnaireRequest,
): Promise<QuestionnaireAnswersResponse> {
	const response = await api.put<QuestionnaireAnswersResponse>(
		"/api/questionnaire-answers",
		data,
	);
	return response.data;
}
